export enum EventCheckInEventsEnum {
	Subscribe = 'event-check-in.subscribe',
	Unsubscribe = 'event-check-in.unsubscribe',
	TicketChanged = 'event-check-in.ticket.changed',
	TicketCreated = 'event-check-in.ticket.created',
}
